import script from "./add-to-cart-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./add-to-cart-button.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__